import { Route, Routes } from "@angular/router";
import { IPermission } from "common/constant/IPermission";
import { RoutePath } from "common/constant/route-path";
import { UserPermissions } from "common/constant/UserPermissions";
import { AdminComponent } from "components/admin/admin.component";
import { AnalyzeComponent } from "components/analyze/analyze.component";
import { DashboardComponent } from "components/dashboard/dashboard.component";
import { EdgeDeviceDashboardComponent } from "components/edge-device-dashboard/edge-device-dashboard.component";
import { ForgotPasswordComponent } from "components/forgot-password/forgot-password.component";
import { LoginComponent } from "components/login/login.component";
import { VisualComponent } from "components/quicksight/visual/visual.component";
import { ReportsComponent } from "components/reports/reports.component";
import { TestComponent } from "components/test/test.component";
import { UserReportsComponent } from "components/user-reports/user-reports.component";
import { UserComponent } from "components/user/user.component";
import { LoginGuardService } from "services/authentication/login-guard/login-guard.service";
import { RoleGuardService } from "services/authentication/role-guard/role-guard.service";
import { Environment } from "src/environments/environment";

export const routes: Routes = createRoutes()

function createRoutes(): Array<Route> {
    const returnValue: Array<Route> = [
        redirect(RoutePath.AppRoot, RoutePath.Login),
        route(RoutePath.Login, LoginComponent, false),
        route(RoutePath.Dashboard, DashboardComponent),
        route(RoutePath.Analyze, AnalyzeComponent),
        route(RoutePath.Administration, AdminComponent),
        // route(RoutePath.EdgeDevice, EdgeDeviceComponent),
        route(RoutePath.EdgeDevice, EdgeDeviceDashboardComponent),
        route(RoutePath.PasswordForgot, ForgotPasswordComponent, false),
        route(RoutePath.User, UserComponent, true, true, [UserPermissions.MaintainUsers]),
        route(RoutePath.Report, ReportsComponent),
        route(RoutePath.Visual, VisualComponent),
        route(RoutePath.UserReport, UserReportsComponent, false),
        ...(Environment.isDevelopment ? [route('test', TestComponent, false)] : []),
        redirect(RoutePath.Invalid, RoutePath.Login),
    ]

    return returnValue
}

function redirect(pattern: string, path: string): Route {
    return {
        path: pattern,
        redirectTo: path,
        pathMatch: 'full',
    }
}

function route(path: string, component: any, loginGuard: boolean = true, roleGuard: boolean = false, permissions?: Array<Array<IPermission>>): Route {
    const canActivate: Array<any> = [
        ...(loginGuard ? [LoginGuardService] : []),
        ...(roleGuard ? [RoleGuardService] : []),
    ]

    const returnValue: Route = {
        path: path,
        component: component,
        pathMatch: 'full',
        canActivate: canActivate,
        data: !!permissions ? { permissions: [permissions] } : undefined
    }

    // const returnValue: Route = {
    //     path: path,
    //     component: component,
    //     pathMatch: 'full',
    //     canActivate: canActivate,
    //     data: undefined
    // }

    return returnValue
}
